export default __webpack_public_path__ + "static/media/line-chart.65439c98.svg";